import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/*
 * Resets scroll on every route change - but if the URL has a #hash,
 * scroll to that element instead (used for deep-linking to sections).
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
